import { StrategyApiResponse } from 'shared/src/api/strategy-api-types';
import { z } from 'zod';

// With ISODateString, TRPC response uses the same type as API response
export const StrategyTrpcResponse = StrategyApiResponse;
export type StrategyTrpcResponse = z.infer<typeof StrategyTrpcResponse>;
